import { Chapter, FadeUp } from "@/components/Reveal";
import { useLanguage } from "@/i18n/LanguageContext";

const PHOTOS = [
  { src: "/assets/team-control.jpg", span: "md:col-span-7", ratio: "aspect-[4/3]", delay: 0.1 },
  { src: "/assets/team-coordinator.jpg", span: "md:col-span-4", ratio: "aspect-[4/3] md:aspect-[3/4]", delay: 0 },
  { src: "/assets/team-registration.jpg", span: "md:col-span-8", ratio: "aspect-[4/3] md:aspect-[16/10]", delay: 0.08 },
  { src: "/assets/team-ballroom.jpg", span: "md:col-span-5", ratio: "aspect-[4/3]", delay: 0 },
  { src: "/assets/team-stage.jpg", span: "md:col-span-7", ratio: "aspect-[4/3] md:aspect-[16/10]", delay: 0.08 },
  { src: "/assets/team-onstage.jpg", span: "md:col-span-12", ratio: "aspect-[4/3] md:aspect-[21/9]", delay: 0.12 },
];

const Tile = ({ src, caption, ratio }) => (
  <div className={`group relative overflow-hidden rounded-2xl border border-white/10 ${ratio}`} data-testid={`team-photo-${src.split("/").pop().split(".")[0]}`}>
    <img
      src={src}
      alt={caption}
      loading="lazy"
      className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.05]"
    />
    <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/70 to-transparent p-5 pt-12">
      <p className="font-spacemono text-[9px] uppercase tracking-[0.3em] text-white/70">{caption}</p>
    </div>
  </div>
);

export default function Team() {
  const { t } = useLanguage();
  const captions = t("team.captions");

  return (
    <section id="team" className="py-28 md:py-40" data-testid="team-section">
      <div className="mx-auto max-w-[1440px] px-6 md:px-12">
        <Chapter number="05" title={t("chapters.team")} />
        <div className="grid grid-cols-1 gap-6 md:grid-cols-12">
          <FadeUp className="flex flex-col justify-center md:col-span-5">
            <h2 className="text-balance font-syne text-3xl font-bold leading-[1.12] tracking-tight sm:text-4xl lg:text-[3.4rem]" data-testid="team-heading">
              {t("team.headingA")} <span className="text-[#F97316]">{t("team.headingB")}</span>
            </h2>
            <p className="mt-8 max-w-md text-sm leading-relaxed text-white/55 md:text-base">{t("team.intro")}</p>
          </FadeUp>
          <FadeUp delay={PHOTOS[0].delay} className={PHOTOS[0].span}>
            <Tile src={PHOTOS[0].src} caption={captions[0]} ratio={PHOTOS[0].ratio} />
          </FadeUp>
          {PHOTOS.slice(1).map((p, i) => (
            <FadeUp key={p.src} delay={p.delay} className={p.span}>
              <Tile src={p.src} caption={captions[i + 1]} ratio={p.ratio} />
            </FadeUp>
          ))}
        </div>
      </div>
    </section>
  );
}
